import { Grid, Skeleton } from '@mui/material';

const BudgetMonthLoadingSkeleton = () => {
  return (
    <Grid container spacing={0}>
      <Grid
        item
        xs={12}
        md={8}
        sx={{
          borderRight: {
            xs: 'none',
            md: '1px solid #e0e0e0'
          },
          pr: {
            xs: 0,
            md: 4
          }
        }}
      >
        <Skeleton variant="rectangular" height={40} sx={{ mb: 2 }} />
        <Skeleton variant="rectangular" height={200} sx={{ mb: 2 }} />
        <Skeleton variant="rectangular" height={200} sx={{ mb: 2 }} />
        <Skeleton variant="rectangular" height={100} sx={{ mb: 2 }} />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
        sx={{ pl: { xs: 0, md: 4 }, mt: { xs: 4, md: 0 } }}
      >
        <Skeleton variant="rectangular" height={400} sx={{ mb: 2 }} />
      </Grid>
    </Grid>
  );
};

export default BudgetMonthLoadingSkeleton;
